export const getMedia = (mediaHash, pt = '') => {
  const url =
    process.env.REACT_APP_DEBUG === 'true' ? process.env.REACT_APP_URL_DEBUG : process.env.REACT_APP_URL_PRODUCT;
  return `${url}/media/?hh=${mediaHash}&pt=${pt}`;
};
